import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FrontEndRoutes } from "../../config/front-end-routes";
import CustomerPriceTable from "../../Components/FormCustomer/CustomerPriceTable";
import { BackEndRoutes } from "../../config/back-end-routes";
import { api } from "../../config/api";
import CustomerRequests from "../../Components/FormCustomer/CustomerRequests";
import GridClients from "../../Components/Grid/GridClients";
import { toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";

interface UserData {
  id_tipo: number | null;
  id_usuario: number | null;
  nome: string;
  email: string;
  senha: string;
  senha_confirmation: string;
  tabela: { id_tabela: number };
  status: number;
}

const PageUsuario: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<string>();
  const [pedidos, setPedidos] = useState([])
  const [clientes, setClientes] = useState([])
  const [userData, setUserData] = useState<UserData>({
    id_tipo: null,
    id_usuario: null,
    nome: "",
    email: "",
    senha: "",
    senha_confirmation: "",
    tabela: { id_tabela: 0 },
    status: 1,
  });
  const [invalidFields, setInvalidFields] = useState({
    nome: false,
    email: false,
    senha: false,
    senha_confirmation: false,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setUserData((prev) => ({ ...prev, [id]: value }));
    setInvalidFields((prev) => ({ ...prev, [id]: false }));
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    if (id === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setInvalidFields((prev) => ({ ...prev, email: true }));
      }
    }
    if (!value) {
      setInvalidFields((prev) => ({ ...prev, [id]: true }));
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(BackEndRoutes.routes.USUARIOS.FIND.replace(":id", id));
      const data = response.data;
      setUserData({
        ...userData,
        nome: data.nome,
        email: data.email,
        tabela: { id_tabela: data.id_tabela },
      });
      setPedidos(data.pedidos || [])
      setClientes(data.clientes || [])
    } catch (error) {
      console.error("Erro ao buscar o cliente", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data: UserData) => {
    setLoading(true);
    try {
      if (id) {
        await api.put(BackEndRoutes.routes.USUARIOS.UPDATE.replace(":id", id), data);
      } else {
        await api.post(BackEndRoutes.routes.USUARIOS.POST, data);
      }
      toast.success("Usuário salvo com sucesso!");
      navigate(FrontEndRoutes.USUARIOS.LIST);
    } catch (error) {
      toast.error("Erro ao salvar usuário.");
    } finally {
      setLoading(false);
    }
  };

  const saveFunction = () => {
    const newInvalidFields = {
      nome: !userData.nome,
      email: !userData.email,
      senha: !userData.senha,
      senha_confirmation: !userData.senha_confirmation || userData.senha !== userData.senha_confirmation,
    };
    setInvalidFields(newInvalidFields);

    const isValid = !Object.values(newInvalidFields).some((field) => field);
    if (isValid) {
      handleSave(userData);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  useEffect(() => {
    if (!loading) {
      setActiveTab(clientes.length === 0 ? "pedidos" : "clientes");
    }
  }, [clientes, loading]);

  return (
    <div className="d-flex flex-column mb-3 gap-2 container-fluid">
      <div className="card border-primary h-100 ">
        <h3 className="text-center mt-4">Dados do Usuário</h3>
        <div className="card-body row d-flex align-items-center h-100">
          <div className="container-fluid">
            <div className="row">
              <div className="">
                <label>Login</label>
                <input
                  id="nome"
                  className={`form-control ${invalidFields.nome ? "is-invalid" : ""}`}
                  type="text"
                  value={userData.nome}
                  placeholder="Login"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <p className="invalid-feedback">Insira um Login</p>
              </div>
              <div className="col-md-6 col-lg-6">
                <label>Email</label>
                <input
                  id="email"
                  className={`form-control ${invalidFields.email ? "is-invalid" : ""}`}
                  type="text"
                  value={userData.email}
                  placeholder="email@dominio.com"
                  autoComplete="off"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <p className="invalid-feedback">Insira no formato email@dominio.com</p>
              </div>
              <div className="col-md-6 col-lg-6">
                <label>Senha</label>
                <input
                  id="senha"
                  className={`form-control ${invalidFields.senha ? "is-invalid" : ""}`}
                  type="password"
                  value={userData.senha}
                  placeholder="Senha"
                  autoComplete="off"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <p className="invalid-feedback">Insira uma Senha</p>
              </div>
              <div className="col-md-6 col-lg-6">
                <label>Confirmar Senha</label>
                <input
                  id="senha_confirmation"
                  className={`form-control ${invalidFields.senha_confirmation ? "is-invalid" : ""}`}
                  type="password"
                  value={userData.senha_confirmation}
                  placeholder="Confirmar Senha"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <p className="invalid-feedback">As senhas não coincidem</p>
              </div>
              <div className="col-md-6 col-lg-6">
                <label>Tabela de Preço</label>
                <CustomerPriceTable setCustomerData={setUserData} customerData={userData} />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer d-flex col gap-4 justify-content-end">
          <Button
            type="button"
            className="mt-3"
            variant="secondary"
            disabled={loading}
            onClick={() => navigate(FrontEndRoutes.USUARIOS.LIST)}>
            {loading ? <Spinner animation="border" size="sm" /> : "Voltar"}
          </Button>
          <Button type="submit" className="mt-3" disabled={loading} onClick={saveFunction}>
            {loading ? <Spinner animation="border" size="sm" /> : "Salvar"}
          </Button>
        </div>
      </div>
      <div className={`card h-100 ${pedidos.length !== 0 || clientes.length !== 0 ? "" : "d-none"}`}>
        <div className="card-header">
          <ul className="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
            <li className="nav-item outline-black " role="presentation">
              <button
                className={`nav-link ${clientes?.length !== 0 ? "" : "d-none "} ${activeTab === "clientes" ? "active" : "text-black"}`}
                id="clientes-tab"
                type="button"
                onClick={() => setActiveTab("clientes")}
              >
                Clientes
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                className={`nav-link	${pedidos?.length !== 0 ? "" : "d-none "} ${activeTab === "pedidos" ? "active" : "text-black"}`}
                id="pedidos-tab"
                type="button"
                onClick={() => setActiveTab("pedidos")}
              >
                Pedidos
              </button>
            </li>
          </ul>
        </div>

        <div className="tab-content mt-3 border border-top-0 rounded-bottom" id="myTabContent">

          {/* Clientes */}
          <div
            className={`tab-pane fade ${clientes && clientes?.length !== 0 ? "" : "d-none "} ${activeTab === "clientes" ? "show active" : ""}`}
            id="clientes"
            role="tabpanel"
            aria-labelledby="pedidos-tab"
          >
            <div className="card-body">
              <GridClients
                clients={clientes}
                reload={getData} />
            </div>
          </div>

          {/* Pedidos */}
          <div
            className={`tab-pane fade ${activeTab === "pedidos" ? "show active" : ""}`}
            id="pedidos"
            role="tabpanel"
            aria-labelledby="pedidos-tab"
          >
            <div className="card-body">
              <CustomerRequests
                pedidos={pedidos}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageUsuario;
